let directive = {
	value_format: {
		bind: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;

			valor = vnode.context.$helper.formatValue(format, valor);

			el.innerHTML = valor;
		}
	},

	date_format: {
		bind: function(el, binding, vnode){

			let valor  = binding.value.data;
			let format = binding.value.format;
			
			valor = vnode.context.$helper.formatDate(format, valor);

			el.innerHTML = valor;

			let title;

			if(format == 1){
				title = 'DD/MM/YYYY';
			}else{
				title = 'MM/DD/YYYY';
			}
			
			/*
			$(el).tooltip({
				"animation": false,
				"title": 	title,
				"trigger": 'hover'
			});
			*/

		}
	}
}


export default directive
